import { Button } from 'antd';
import React from 'react';
import { useHistory } from 'react-router';

interface IProps {
	noteGroupId: string;
	disabled: boolean;
}

export const AddLossNote = (props: IProps) => {
	const history = useHistory();

	return (
		<Button
			size="large"
			shape="round"
			disabled={props.disabled}
			type="primary"
			onClick={() => {
				history.push(`/lossNote/create/${props.noteGroupId}`);
			}}
		>
			Internal Loss
		</Button>
	);
};
